// extracted by mini-css-extract-plugin
export default {"details":"BusinessDetails_details__sqggp","name":"BusinessDetails_name__ZLsbw"};